import { render, staticRenderFns } from "./PlotRecommenderPriceFilter.vue?vue&type=template&id=21c7003c&scoped=true"
import script from "./PlotRecommenderPriceFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotRecommenderPriceFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlotRecommenderPriceFilter.vue?vue&type=style&index=0&id=21c7003c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7003c",
  null
  
)

export default component.exports